/**
 * The values a route's search parameters may take.
 *
 * In their own module, away from the pages that use them, because the
 * router validates search params and so has to import them — and anything
 * the router imports is in the first chunk the browser downloads. Left on
 * `SchedulePage` and `FilesPage`, these three lines pulled both of those
 * pages (and everything they import) into the bundle that the sign-in
 * screen and the homeowner's portal load, which is what P4-25 was about.
 */
export const SCHEDULE_VIEWS = ['list', 'calendar', 'gantt'] as const;
export type ScheduleView = (typeof SCHEDULE_VIEWS)[number];

export const FILE_ROOTS = ['documents', 'photos', 'videos'] as const;
export const FILE_VIEWS = ['list', 'grid'] as const;
export type FileView = (typeof FILE_VIEWS)[number];
